/*
 * 全局通讯文件，解决不同组件间的通讯
 * type在 /modules/globals/constants/behaviorSubject.js
 * */
import { BehaviorSubject } from 'rxjs/internal/BehaviorSubject'

export default new BehaviorSubject({})
